/** en-GB messages added by Phase 4 fix task FX1 (support-session limits, sealed platform secrets). Only that task edits this file. */
export const fx1EnGB = {
    'error.support_session_refused': "This cannot be done in a CloudSign support session. Ask the organisation's own administrator.",
    'domain.error.slug_changed': 'Switched off because the organisation address changed. Add the new address instead.',
    'platformSecrets.title': 'Secrets',
    'platformSecrets.description': 'Secret values are stored encrypted and are never shown again.',
    'platformSecrets.entra': 'Microsoft Entra client secret',
    'platformSecrets.expo': 'Expo push access token',
    'platformSecrets.isSet': 'A value is stored',
    'platformSecrets.notSet': 'Not set',
    'platformSecrets.hint': 'Type a new value to replace it. Leave empty and press Clear to remove it.',
    'platformSecrets.set': 'Set secret',
    'platformSecrets.clear': 'Clear',
    'platformSecrets.saved': 'Secret saved.',
    'error.settings_sealed_key': 'Secret values cannot be set here. Use the dedicated secret field.',
};
//# sourceMappingURL=fx1.js.map